export default function Title({Elem = 'h2', size = 'large', children, className = '', ...rest}) {
    const sizeClasses = size === 'large' ? 'text-1.5xl md:text-4xl' : 'text-xl md:text-2xl';

    return (
        <Elem className={`${sizeClasses} font-semibold bold-accent-color ${className}`}
              {...rest}
              dangerouslySetInnerHTML={{__html: children}}
        />
    )
}